import { useState, useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { useGetAllVideos } from './useGetAllVideos';
import { setAllVideos } from '../context/allVideosSlice';
import { useDispatch } from 'react-redux';


export const useCreateAllVideosTree = () => {
    const [myArray, setArray] = useState([]);
    const dispatch = useDispatch()

    const { data: allVideos } = useGetAllVideos()
    dispatch(setAllVideos(allVideos))


    useEffect(() => {
        const updateArray = (id, parent, droppable, text) => {
            const newItem = {
                id: id,
                parent: parent,
                droppable: droppable,
                text: text
            };

            setArray(prevArray => [...prevArray, newItem]);
        };

        const allFolders = allVideos && allVideos.map(video => video.folder)
        var uniqueFolders = []
        allFolders && allFolders.map(folder => {
            if (uniqueFolders.indexOf(folder) === -1) {
                uniqueFolders.push(folder)
            }
            return null
        });

        uniqueFolders = uniqueFolders.sort()

        var rootObjects = []
        uniqueFolders && uniqueFolders.map(folder => {
            const folderid = uuid()
            var fnames = folder.split("/")
            if (fnames !== undefined && fnames.length > 1) {
                const rootName = fnames[0]
                var obj = null
                var parentid = uuid()
                if (rootObjects && rootObjects.length > 0) {
                    obj = rootObjects.find((entry) => {
                        if (entry.name === rootName) {
                            return entry
                        }
                        return null
                    })
                    if (!obj) {
                        rootObjects.push({ id: parentid, name: rootName })
                    }
                } else {
                    rootObjects.push({ id: parentid, name: rootName })
                }
                if (obj) {
                    parentid = obj.id
                } else {
                    updateArray(parentid, 0, true, rootName)
                }
                updateArray(folderid, parentid, true, fnames[1])
            } else {
                rootObjects.push({ id: folderid, name: folder })
                updateArray(folderid, 0, true, folder)
            }
            allVideos && allVideos.filter(p => p.folder === folder).map(prog => {
                updateArray(prog.id, folderid, false, prog.name)
                return null
            })
            return null
        })
        // Clean up function
        return () => {
            setArray([]); // Reset the array when the component unmounts
        };
    }, [allVideos]);

    return { myArray, setArray };
};
